module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__companies"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.companiesAmount,
      "link": "",
      "table-id": "companies",
      "showAddButton": true
    },
    on: {
      "create": _vm.addCompany,
      "refresh": _vm.getCompanies
    },
    scopedSlots: _vm._u([{
      key: "is_default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.is_default === '1') ? 'Да' : 'Нет'))])]
      }
    }, {
      key: "nds",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((scope.item.nds === '1') ? 'Да' : 'Нет'))])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.companies),
      callback: function($$v) {
        _vm.companies = $$v
      },
      expression: "companies"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4470cba7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/companies/views/Companies.vue
// module id = 1122
// module chunks = 0